import { map, pick, isNull } from 'lodash/fp';
import moment from 'moment';
import { hasOwnProperty } from '../../utils/fp';

const DATE_FORMAT = 'YYYY-MM-DD';
const ASSIGNABLE_DATA_ATTR = 'data-current-assignable-item';
const getIds = item => pick(['id', 'type'], item);

export function buildAssignment(getState, state, contentType = 'Training') {
  const {
    selection: { content, assignees },
    schedule: {
      recurring,
      recurringOptions,
      dueDate,
      assignDate,
      assignTime,
      timeZone,
    },
    existingAssignments,
    message,
  } = state || getState();

  const journeyContent = content.data.filter(x => x.type === 'Journey');
  const trainingContent = content.data.filter(x => x.type !== 'Journey');
  const contentData =
    contentType === 'Journeys' ? journeyContent : trainingContent;

  return {
    content: map(getIds, contentData),
    assignees: map(getIds, assignees.data),
    schedule: {
      recurring,
      ...(recurring && { recurringOptions }),
      dueDate: dueDate && moment(dueDate).format(DATE_FORMAT),
      assignDate: assignDate
        ? moment(assignDate).format(DATE_FORMAT)
        : assignDate,
      assignTime,
      timeZone,
    },
    existingAssignments,
    message,
  };
}

export function getAssignableIdentity() {
  return new Promise((resolve, reject) => {
    const assignableItem = document.body.getAttribute(ASSIGNABLE_DATA_ATTR);
    if (assignableItem) {
      let data;
      try {
        data = JSON.parse(assignableItem);
      } catch (error) {
        reject(error);
      }

      const isAssignable = ['id', 'type'].every(
        key => hasOwnProperty(data, key) && !isNull(data[key]),
      );

      if (isAssignable) {
        resolve(data);
      } else {
        reject(new Error('Failed to identify assignable item data'));
      }
    } else {
      reject(new Error('Page does not contain assignable item'));
    }
  });
}

export function registerAssignableIdentity(data) {
  const identity = pick(['id', 'type', 'title', 'name', 'meta'])(data);
  document.body.setAttribute(ASSIGNABLE_DATA_ATTR, JSON.stringify(identity));
}
